import styled from "styled-components";
import { motion } from "framer-motion";

export const DifficultyWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.6rem;
  padding: 2.4rem 2rem;
  background-color: var(--color-dark-purple);
  border: 3px solid var(--color-black);
  box-shadow: 0 0.8rem 0 var(--color-black);
  border-radius: 1.6rem;
`;

export const Header = styled.h2`
  font-size: var(--font-size-heading-s);
  font-weight: bold;
  letter-spacing: var(--letter-spacing-heading-m);
  color: var(--color-white);
  text-transform: uppercase;
  opacity: 0.7;
`;

export const DifficultyList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  width: 100%;
`;

export const DifficultyItem = styled.button<{
  variant: "easy" | "normal" | "hard";
}>`
  width: 100%;
  cursor: pointer;
  font-size: var(--font-size-heading-xs);
  font-weight: bold;
  font-family: inherit;
  letter-spacing: var(--letter-spacing-heading-m);
  text-transform: uppercase;
  padding: 1rem 2.4rem;
  border-radius: 1.2rem;
  border: 2px solid var(--color-black);
  transition: all 0.15s;

  background: ${({ variant }) =>
    variant === "easy"
      ? "var(--color-white)"
      : variant === "normal"
        ? "var(--color-yellow)"
        : "var(--color-red)"};

  color: ${({ variant }) =>
    variant === "hard" ? "var(--color-white)" : "var(--color-black)"};

  box-shadow: ${({ variant }) =>
    variant === "easy"
      ? "0 0.4rem 0 rgba(0,0,0,0.4)"
      : variant === "normal"
        ? "0 0.4rem 0 rgba(0,0,0,0.4)"
        : "0 0.4rem 0 rgba(0,0,0,0.5)"};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 0.6rem 0 rgba(0, 0, 0, 0.4);
  }
  &:active {
    transform: translateY(2px);
    box-shadow: none;
  }
`;

export const CloseBtn = styled.button`
  margin-top: 0.4rem;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.25);
  border-radius: 1rem;
  padding: 0.6rem 2rem;
  color: var(--color-white);
  font-size: 1.3rem;
  font-family: inherit;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
  }
`;
